import { Component } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
	selector: 'cmv-confirm-modal',
	templateUrl: './confirm-modal.component.html',
	styleUrls: ['./confirm-modal.component.scss'],
})
export class ConfirmModalComponent {
	modalText: string = 'Text';
	btnText: string = 'OK';

	constructor(private activeModal: NgbActiveModal) {}

	onConfirm(): void {
		this.activeModal.close(true);
	}

	dismissModal(): void {
		this.activeModal.close();
	}
}
